import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClassificacaoSkincareComponent } from './classificacao-skincare.component';

const routes: Routes = [{ path: '', component: ClassificacaoSkincareComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClassificacaoSkincareRoutingModule {}
